import React, { useState, useCallback, useEffect } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import Card from 'components/inputs/Card';
import { BsSearch } from 'react-icons/bs';
import Button from 'components/inputs/Button';
import { FiEdit2 } from 'react-icons/fi';
import { RiDeleteBinLine } from 'react-icons/ri';
import { Row, Col } from 'react-bootstrap';
import * as _ from 'lodash';
import SearchBox from 'components/general/SearchBox';
import { useDispatch, useSelector } from 'react-redux';
// import Pagination from 'components/general/Pagination';
import ReactPagination from 'components/general/ReactPagination';
import { Modal } from 'react-bootstrap';
import { DELETE_PERMISSION, FETCH_PERMISSION, GET_PERMISSION } from 'actions/permissions';
import DeleteModal from 'components/general/DeleteModal';
import { DELETE_STATUS_CODE } from 'components/common/constant';
import { BiSort } from 'react-icons/bi';
import PermissionForm from './PermissionForm';
import { useTranslation } from 'react-i18next';

const PermissionList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  // const [allPermissionData, setAllPermissionData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [permissionId, setPermissionId] = useState('');
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });

  const page = useSelector((state) => state.permissions.page);
  const totalData = useSelector((state) => state.permissions.total);
  const limit = useSelector((state) => state.permissions.limit);
  const totalPages = useSelector((state) => state.permissions.totalPages);
  const permissionList = useSelector((state) => state.permissions.permissions);

  const getPermission = useCallback(
    (data = {}) => {
      if (searchText) {
        const permissionData = {
          ...data,
          search: searchText,
        };
        dispatch({ type: FETCH_PERMISSION.REQUEST, payload: permissionData });
      } else {
        dispatch({ type: FETCH_PERMISSION.REQUEST, payload: data });
      }
    },
    [searchText]
  );

  const getPermissionDetail = useCallback((id) => {
    dispatch({ type: GET_PERMISSION.REQUEST, payload: id });
  }, []);

  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
    setPermissionId('');
  };

  const deletePermission = useCallback(
    () =>
      dispatch({
        type: DELETE_PERMISSION.REQUEST,
        payload: permissionId,
        cb: (res) => {
          if (_.get(res, 'status', '') === DELETE_STATUS_CODE) {
            handleCloseDeleteModel();
            getPermission({ page: 1 });
          }
        },
      }),
    [permissionId]
  );

  useEffect(() => {
    getPermission();
  }, [searchText]);

  const handleSearch = () => {
    getPermission({});
  };

  // useEffect(() => {
  //   setAllPermissionData(_.filter(permissionList, (item) => startsWith(_.get(item, 'name', ''), searchText)));
  // }, [searchText, permissionList]);

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else {
        const data = {
          page: page.selected + 1,
        };
        getPermission(data);
      }
    },
    [sortByItem]
  );

  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';
    if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      getPermission(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      getPermission(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const handleCloseFormPermission = () => {
    setShowForm(false);
    setIsEdit(false);
  };

  return (
    <>
      <LayoutContainer>
        <AdminHeader title={t('header.permissions')} />
        <div className="page-content-wrapper scrollable">
          <div className="permissionList-page">
            <Card>
              <div className="permissionList-page-wrapper">
                <Row className="permissionList-search-box">
                  <Col xl={10} lg={9} md={8} className="permissionList-search-inputBox">
                    <SearchBox
                      value={searchText}
                      preIcon={<BsSearch />}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          handleSearch();
                        }
                      }}
                    />
                  </Col>
                  <Col xl={2} lg={3} md={4} className="permissionList-search-boxButton">
                    <Button
                      className="permissionList-search-box-Btn"
                      onClick={() => {
                        setShowForm(true);
                        setIsEdit(false);
                      }}
                    >
                      {t('button.addPermission')}
                    </Button>
                  </Col>
                </Row>
                <div className="permissionList-table">
                  <div className="table-responsive">
                    <table className="record-list-table">
                      <thead>
                        <tr>
                          <th>
                            <div className="sorting">
                              <span>{t('permissionForm.permissionName')}</span>
                              <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th className="action-col">
                            <span>{t('permissionForm.action')}</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {_.isEmpty(permissionList) ? (
                          <tr>
                            <td colSpan={3} className="border-0">
                              <div className="empty-data-block">{t('permissionForm.noData')}</div>
                            </td>
                          </tr>
                        ) : (
                          _.map(permissionList, (item, key) => {
                            return (
                              <>
                                <tr key={`permission-${key}`}>
                                  <td>{_.get(item, 'name', '')}</td>
                                  <td>
                                    <span
                                      className="permissionList-table-editIcon"
                                      onClick={() => {
                                        setShowForm(true);
                                        getPermissionDetail(_.get(item, 'id', ''));
                                        setIsEdit(true);
                                      }}
                                    >
                                      <FiEdit2 title="Edit" />
                                    </span>
                                    <span
                                      className="permissionList-table-deleteIcon"
                                      onClick={() => {
                                        setShowDeleteModal(true);
                                        setPermissionId(_.get(item, 'id', ''));
                                      }}
                                    >
                                      <RiDeleteBinLine title="Delete" />
                                    </span>
                                  </td>
                                </tr>
                              </>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {!_.isEmpty(permissionList) && (
                  <ReactPagination
                    currentPage={page}
                    limit={limit}
                    total={totalData}
                    handlePageClick={(pageVal) => handlePageClick(pageVal)}
                    totalPages={totalPages}
                    marginPagesDisplayed={1}
                  />
                  // <Pagination currentPage={page} limit={limit} total={totalData} onPageChange={(pageVal) => handlePageClick(pageVal)} />
                )}
              </div>
            </Card>
          </div>
        </div>
        {showForm && (
          <Modal show={showForm} size="lg" centered>
            <PermissionForm onClose={handleCloseFormPermission} isEdit={isEdit} onSuccess={getPermission} />
          </Modal>
        )}
        {showDeleteModal && (
          <Modal show={showDeleteModal} centered onHide={handleCloseDeleteModel}>
            <DeleteModal title="permission" onClose={handleCloseDeleteModel} onRemove={deletePermission} />
          </Modal>
        )}
      </LayoutContainer>
    </>
  );
};
export default PermissionList;
